export default __webpack_public_path__ + "static/media/file.9b3c2535.svg";